import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import * as React from "react";
import * as ThemeConstants from "../../../Styles/Constants";
import { useWindowDimensions } from "../UseWindowDimensions";

interface Props {
    invalidLetters: string[];
    positionLetters: string[];
    matchLetters: string[];
    onKeyPressed: (key: string) => void;
    invalidColor?: string;
    positionColor?: string;
    matchColor?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        },
        keyRow: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        key: {
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: ThemeConstants.PALETTE_WHITE
        }
    })
);

const KEYBOARD_KEYS = [
    ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
    ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
    ["ENTER", "Z", "X", "C", "V", "B", "N", "M", "DEL"]
];

export const Keyboard = (props: Props) => {
    const classes = useStyles();
    const { width, height } = useWindowDimensions();

    const small = width < 600;
    const boxSize = small ? 37 : 75;
    const boxGap = small ? "0.2rem" : "0.4rem";
    const fontSize = small ? 12 : 24;

    return (
        <div className={classes.root} style={{ gap: boxGap, bottom: width < 600 ? "1rem" : "2rem" }}>
            {
                KEYBOARD_KEYS.map((r, i) => {
                    return (
                        <div className={classes.keyRow} key={i} style={{ gap: boxGap }}>
                            {
                                r.map((k, j) => {
                                    const baseWidth = width < 600 ? width / (r.length) : boxSize;
                                    const finalWidth = k == "ENTER" || k == "DEL" ? baseWidth * 1.05 : baseWidth * 0.9;
                                    const finalHeight = height / 14;

                                    let bkgColor = props.invalidColor ?? ThemeConstants.GAME_BOX_DEFAULT_COLOR;
                                    let opacity = "1.0";
                                    if (props.invalidLetters.includes(k.toLowerCase()))
                                        opacity = "0.2";
                                    if (props.positionLetters.includes(k.toLowerCase())) {
                                        bkgColor = props.positionColor ?? ThemeConstants.GAME_BOX_POSITION_COLOR;
                                        opacity = "1.0";
                                    }
                                    if (props.matchLetters.includes(k.toLowerCase())) {
                                        bkgColor = props.matchColor ?? ThemeConstants.GAME_BOX_MATCH_COLOR;
                                        opacity = "1.0";
                                    }

                                    return (
                                        <Button
                                            className={classes.key}
                                            key={j}
                                            onClick={() => props.onKeyPressed(k)}
                                            style={{
                                                transition: "opacity 100ms ease 0s, background-color 100ms ease 0s",
                                                backgroundColor: bkgColor,
                                                width: finalWidth,
                                                minWidth: finalWidth,
                                                height: finalHeight,
                                                minHeight: finalHeight,
                                                fontSize: fontSize,
                                                opacity
                                            }}
                                        >
                                            {k}
                                        </Button>
                                    );
                                })
                            }
                        </div>
                    );
                })
            }
        </div>
    );
}